// extracted by mini-css-extract-plugin
module.exports = {"link":"AvatarIconAndNameLink_link__YyH3h"};